"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.projectModuleLabels = exports.ProjectModuleName = void 0;

var _projectModuleLabels;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ProjectModuleName;
exports.ProjectModuleName = ProjectModuleName;

(function (ProjectModuleName) {
  ProjectModuleName["AIR_EMISSIONS"] = "airEmissions";
  ProjectModuleName["BMP"] = "bmp";
  ProjectModuleName["COVID_19_RESPONSE_BUILDER"] = "covid19ResponseBuilder";
  ProjectModuleName["HMBP"] = "hmbp";
  ProjectModuleName["SPCC"] = "spcc";
  ProjectModuleName["STORMWATER"] = "stormwater";
  ProjectModuleName["STORMWATER_LVL_1"] = "stormwaterLvl1";
  ProjectModuleName["STORMWATER_VISUAL"] = "stormwaterVisual";
  ProjectModuleName["SWPPP"] = "swppp";
  ProjectModuleName["TRACKOUT"] = "trackout";
  ProjectModuleName["WASTEWATER"] = "wastewater";
})(ProjectModuleName || (exports.ProjectModuleName = ProjectModuleName = {}));

var projectModuleLabels = (_projectModuleLabels = {}, _defineProperty(_projectModuleLabels, ProjectModuleName.AIR_EMISSIONS, 'Air Visual Emissions'), _defineProperty(_projectModuleLabels, ProjectModuleName.BMP, 'BMP'), _defineProperty(_projectModuleLabels, ProjectModuleName.COVID_19_RESPONSE_BUILDER, 'COVID-19 Response Plan Builder'), _defineProperty(_projectModuleLabels, ProjectModuleName.HMBP, 'HMBP'), _defineProperty(_projectModuleLabels, ProjectModuleName.SPCC, 'SPCC'), _defineProperty(_projectModuleLabels, ProjectModuleName.STORMWATER, 'Stormwater Routine'), _defineProperty(_projectModuleLabels, ProjectModuleName.STORMWATER_LVL_1, 'Stormwater Exceedance Level 1'), _defineProperty(_projectModuleLabels, ProjectModuleName.STORMWATER_VISUAL, 'Stormwater Visual'), _defineProperty(_projectModuleLabels, ProjectModuleName.SWPPP, 'SWPPP'), _defineProperty(_projectModuleLabels, ProjectModuleName.TRACKOUT, 'Track Out'), _defineProperty(_projectModuleLabels, ProjectModuleName.WASTEWATER, 'Wastewater'), _projectModuleLabels);
exports.projectModuleLabels = projectModuleLabels;